import { ArrowRight } from '@/components/ui/icons';
import { cn } from '@/lib/utils';

interface PromptLogoProps {
  isLoaded: boolean;
}

export function PromptLogo({ isLoaded }: PromptLogoProps) {
  return (
    <div className="mx-auto mt-10 flex max-w-3xl flex-col items-center justify-center md:mt-14 lg:mt-16">
      <div
        className={cn(
          'mb-4 flex flex-col items-center justify-center gap-2 md:mb-6 md:gap-3',
          'motion-safe:transition-opacity motion-safe:duration-1000 motion-safe:ease-out',
          isLoaded ? 'opacity-100' : 'opacity-0',
        )}
      >
        <span
          aria-hidden="true"
          className="relative inline-block h-10 w-10 shrink-0 md:h-14 md:w-14 lg:h-16 lg:w-16"
        >
          <img
            src="/telekinesis-logo.png"
            alt="Telekinesis"
            className="absolute inset-0 h-full w-full object-contain"
          />
        </span>
        <span className="text-xl font-bold tracking-tight text-telekinesis-text-primary md:text-3xl lg:text-4xl">
          Telekinesis
        </span>
      </div>
    </div>
  );
}

interface PromptSubtitleProps {
  isLoaded: boolean;
  onMarketplaceClick: () => void;
}

export function PromptSubtitle({
  isLoaded,
  onMarketplaceClick,
}: PromptSubtitleProps) {
  return (
    <div className="mx-auto flex max-w-3xl flex-col items-center justify-center">
      <h1
        className={cn(
          'mb-6 text-center font-medium leading-snug text-telekinesis-text-secondary',
          'motion-safe:transition-opacity motion-safe:duration-1000 motion-safe:ease-out',
          isLoaded ? 'opacity-100' : 'opacity-0',
        )}
      >
        {/* Mobile: single condensed line */}
        <span className="block text-[1.2rem] md:text-[1.35rem] lg:hidden">
          Text to CAD by Sea, Air, Land, and Space
        </span>
        {/* Desktop: two lines, no periods */}
        <span className="hidden text-2xl lg:block">
          Automated CAD by Sea, Air, Land, and Space
        </span>
        <span className="hidden text-[1.31rem] lg:block">
          Use Telekinesis to move matter with your mind.
        </span>
      </h1>
      {/* Desktop marketplace button — hidden at lg+ (moved to TopToolbar) */}
      <button
        onClick={onMarketplaceClick}
        className="mb-6 hidden items-center rounded-xl border border-telekinesis-neutral-700 bg-telekinesis-bg-dark px-5 py-3 transition-colors hover:border-telekinesis-gold hover:bg-telekinesis-neutral-900 md:flex lg:hidden"
      >
        <span className="h-4 w-4 shrink-0" />
        <div className="mx-4 text-center">
          <p className="text-sm font-semibold text-[#107d40]">Marketplace</p>
          <p className="whitespace-nowrap text-xs text-telekinesis-text-secondary">
            Buy and Sell Designs, 3D Printed &amp; shipped to your door.
          </p>
        </div>
        <ArrowRight className="h-4 w-4 shrink-0 text-telekinesis-text-secondary" />
      </button>
    </div>
  );
}
